// extracted by mini-css-extract-plugin
export default {"selectTariffValueWrapper":"PaymentPeriodCheckbox_selectTariffValueWrapper__SIU+f"};